module.exports = __webpack_public_path__ + "img/progress-coin.6cbea171.svg";